import { lang } from "../../i18nLang";
import { NotFoundException } from "./NotFoundException";

export class InvalidCredentialsException extends Error {
  protected _code: string;

  constructor() {
    super("Invalid Credentials");

    this.name = "InvalidCredentialsException";
    this._code = "invalidCredentials";
  }

  get customMessage() {
    return lang("exceptions.megaIntegration.invalidCredentials");
  }
}

export class NetworkErrorException extends Error {
  protected _code: string;

  constructor() {
    super("Network Error");

    this.name = "NetworkErrorException";
    this._code = "networkError";
  }

  get customMessage() {
    return lang("exceptions.megaIntegration.networkError");
  }
}

export class UserNotFoundException extends NotFoundException {
  protected _code: string;
  private _username: string;

  constructor(username: string) {
    super("user");

    this.name = "UserNotFoundException";
    this._code = "userNotFound";
    this._username = username;
  }

  get customMessage() {
    return lang("exceptions.megaIntegration.userNotFound", this._username);
  }
}

export class UserBlockedException extends Error {
  protected _code: string;
  private _username: string;

  constructor(username: string) {
    super("Blocked Mega User");

    this.name = "UserBlockedException";
    this._code = "userBlocked";
    this._username = username;
  }

  get customMessage() {
    return lang("exceptions.megaIntegration.userBlocked", this._username);
  }
}

export class NoAccessPermissionException extends Error {
  protected _code: string;
  private _username: string;

  constructor(username: string) {
    super("User has no access to Mega API");

    this.name = "NoAccessPermissionException";
    this._code = "noAccessPermission";
    this._username = username;
  }

  get customMessage() {
    return lang(
      "exceptions.megaIntegration.noAccessPermission",
      this._username
    );
  }
}

export class QuotationNotFoundException extends Error {
  protected _code: string;
  private _indicatorName: string;
  private _dateRef: Date;

  constructor(indicatorName: string, date: Date) {
    super("No quotation founded");

    this.name = "QuotationNotFoundException";
    this._code = "quotationNotFound";
    this._indicatorName = indicatorName;
    this._dateRef = date;
  }

  get customMessage() {
    return lang(
      "exceptions.megaIntegration.quotationNotFound",
      this._indicatorName,
      this._dateRef.toLocaleDateString()
    );
  }
}

export class InvalidTenantIdException extends Error {
  protected _code: string;

  constructor() {
    super("TenantId is invalid");

    this.name = "InvalidTenantIdException";
    this._code = "invalidTenantId";
  }

  get customMessage() {
    return lang("exceptions.megaIntegration.invalidTenantId");
  }
}
